import { uid } from "../create-shared";
import type { DividerBlock } from "../types";
import type { BlockDefinition } from "./types";

export function createDividerBlock(): DividerBlock {
  return {
    id: uid(),
    type: 'divider',
    thickness: 1,
    style: 'solid',
    widthPct: 100,
    padding: { top: 12, right: 0, bottom: 12, left: 0 },
  };
}

export const dividerBlockDefinition: BlockDefinition = {
  type: 'divider',
  label: 'Divider',
  create: createDividerBlock,
};
